import { Locale } from "@/Common/Models/Localization/Locale";
import { WalkmeMetadataModel } from "../Models/WalkMeMetaDataModel";

class WalkmeHelper {
    private static isInitialized: boolean = false;

    public static changeLanguage(locale: Locale): void {
        if (!this.isEnabled()) {
            return;
        }

        if (!window.WalkMeAPI) {
            return;
        }

        let language: string = this.GetLanguage(locale);

        if (window.WalkMeAPI.getCurrentLanguage() !== language) {
            if (window.WalkMeAPI.getSupportedLanguages().find((x: any) => x.shortName === language)) {
                window.WalkMeAPI.changeLanguage(language);
            }
            else {
                // Swicth to default if not supported
                window.WalkMeAPI.changeLanguage("");
            }
        }
    }

    public static initializeWalkme(): void {
        if (!this.isEnabled() || this.isInitialized) {
            return;
        }

        this.DefineLanguageProperty();
        this.DefineMetadataProperty();
        this.AddScripts();

        this.isInitialized = true;
    }

    private static AddScripts(): void {
        const walkme = document.createElement("script");
        walkme.type = "text/javascript";
        walkme.async = true;
        walkme.src = cacheStore.ClinicSettingsServices.WalkMeIntegrationUrl;
        document.head.appendChild(walkme);
    }

    private static GetLanguage(locale: Locale): string {
        // Walkme languages are currently defined in title case
        // The default language is an empty string
        return locale === Locale.en ? "" : locale.toString().toTitleCase();
    }

    private static DefineLanguageProperty(): void {
        // the 'walkme_get_language' function is used by walkme to select the default language.
        window.walkme_get_language = function(): string {
            return WalkmeHelper.GetLanguage(sessionStore.locale);
        };
    }

    private static DefineMetadataProperty(): void {
        // the 'walkmeMetadata' property is used into the walkme configuration to enable or disabled actions according to the user context.
        WalkmeMetadataModel.Initialize();
    }

    private static isEnabled(): string {
        return (
            cacheStore?.ClinicSettings?.EnableWalkMe
            && cacheStore?.ClinicSettingsServices?.WalkMeIntegrationUrl
        );
    }
}

export { WalkmeHelper };
